export const LOGIN_SUCCESS = 'AUTH/LOGIN_SUCCESS';
export const SIGNOUT_SUCCESS = 'AUTH/SIGNOUT_SUCCESS';
export const SIGNUP_SUCCESS = 'AUTH/SIGNUP_SUCCESS';
export const SET_IS_VERIFIED = 'AUTH/SET_IS_VERIFIED';
export const SET_IS_APPROVED = 'AUTH/SET_IS_APPROVED';
export const SET_USER_DEVICE_ID = 'AUTH/SET_USER_DEVICE_ID';

export const SHOW_ALERT = 'UI/SHOW_ALERT';
export const HIDE_ALERT = 'UI/HIDE_ALERT';
export const SET_MESSAGE = 'UI/SET_MESSAGE';
export const SET_LOCATION = 'UI/SET_LOCATION';
export const SET_LIGHT_FOOTER = 'UI/SET_LIGHT_FOOTER';
export const SET_POPUP = 'UI/SET_POPUP';
export const HIDE_POPUP = 'UI/HIDE_POPUP';
export const SET_LOAD_SPINNER = 'UI/SET_LOAD_SPINNER';
export const SET_SUBSCRIPTION_POP_UP = 'UI/SET_SUBSCRIPTION_POP_UP';
export const SET_DATA_SUBSCRIPTION_POP_UP = 'UI/SET_DATA_SUBSCRIPTION_POP_UP';

export const GET_ALGOLIA_SEARCH_HC_PROVIDER = 'APP/GET_ALGOLIA_SEARCH_HC_PROVIDER';
export const SET_ALGOLIA_SEARCH_HC_PROVIDER = 'APP/SET_ALGOLIA_SEARCH_HC_PROVIDER';
export const GET_ALGOLIA_SEARCH_USERS = 'APP/GET_ALGOLIA_SEARCH_USERS';
export const SET_ALGOLIA_SEARCH_USERS = 'APP/SET_ALGOLIA_SEARCH_USERS';
export const SET_PATIENTS_HC_PROVIDER = 'APP/SET_PATIENTS_HC_PROVIDER';
export const SET_PATIENTS_VIRUSES = 'APP/SET_PATIENTS_VIRUSES';
export const SET_FIREBASE_USERS = 'APP/SET_FIREBASE_USERS';
export const SET_PATIENTS_DEPENDENTS_VIRUSES = 'APP/SET_PATIENTS_DEPENDENTS_VIRUSES';
export const SET_PATIENTS_ALL_VIRUSES = 'APP/SET_PATIENTS_ALL_VIRUSES';
export const SET_CURRENT_PATIENTS = 'APP/SET_CURRENT_PATIENTS';
export const SET_DATA_PATIENTS_HC_PROVIDER = 'APP/SET_DATA_PATIENTS_HC_PROVIDER';
export const SET_USER_FOR_ID = 'APP/SET_USER_FOR_ID';

export const SET_USER_DATA = 'STRIPE/SET_USER_DATA';
export const SET_SUBSCRIPTION_PLANS = 'STRIPE/SET_SUBSCRIPTION_PLANS';
export const TRIGER_SUBSCRIPTION_POP_UP = 'STRIPE/TRIGER_SUBSCRIPTION_POP_UP';


